//Third party libraries

import NumericMetricWidget from '@/components/Widgets/NumericMetricWidget';
import { kFormatterWithAbbreviation } from '@/utils';
//Services
import { useDashboardData } from '../../../hooks/ReactQueryHooks/useDashboardQuery';
import type { DashboardType } from '../../../types/Analytics';
//Assets and miscellaneous
import { Widget } from '../constants';
import type { IProjectBySourcesResponse } from '../FundsLeftWidget';
//Custom components
import WidgetLayout from '../WidgetLayout';

const DevelopersInvestmentWidget = ({ dashboard }: { dashboard: DashboardType }) => {
  const fetchProjectsBySourcesWidgetData = useDashboardData({
    dashboard,
    widget: Widget.PROJECTS_BY_SOURCES,
  });

  const totalDevelopersInvestments = fetchProjectsBySourcesWidgetData?.data?.data
    ?.filter((source: IProjectBySourcesResponse) => source.source_name.toUpperCase().includes('EQUITY'))
    .reduce((acc: number, next: IProjectBySourcesResponse) => {
      return acc + next.total_amount;
    }, 0);

  const formattedValue = kFormatterWithAbbreviation(String(totalDevelopersInvestments));

  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.PROJECTS_BY_SOURCES} actionsBtnLocation='top-2 right-0'>
      <NumericMetricWidget
        title='Developers Investment'
        value={formattedValue.value ? formattedValue.value : '0'}
        prefix='$'
        suffix={formattedValue.abbreviation ? formattedValue.abbreviation : ''}
      />
    </WidgetLayout>
  );
};

export default DevelopersInvestmentWidget;
